import React, { useEffect, useState, useLayoutEffect} from "react";
import "./generalReports.css";
import FilterBox from "../../Components/filterBox/filterBox";
import Api from "../../services/api";
import TableList from "../../Components/tableList/TableList";
import MessageTable from "../../Components/messageTable/MessageTable";
import InputReport from "../../Components/inputReport/inputReport";
import Button from '../../Components/commonButton/commonButton';
import Spinner from "react-bootstrap/Spinner";
import { Badge, Stack } from "react-bootstrap";
import styles from "../General/details.module.css";
import "./generalReports.css";

const reportMachines = () => {

  const [data, setData] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [filters, setFilters] = useState([]);
  const [control,setControl] = useState([1]);
  const [loading, setLoading] = useState(true);


    //Esse use effect faz a requisição na api e puxa os dados pela primeira vez. Coloquei o nome de componentDidMount() pois ele executa somente na primeira renderização.

    useEffect(() => {
        function firstLoad() {
            let array = [];
            Api.get("/machines")
            .then((response) => {
              
            response.data.forEach(({description,code,factory,department, work_shifts, oee_goal, is_machine}, index) => {

              //console.log(response.data)
              
              let workshifts = [];

              work_shifts.forEach((ws, ws_index)=>{
                Api.get(`/work-shifts/${ws}`).then((response1)=>{

                  //console.log(response1)

                  workshifts.push(<Badge variant="secondary">{response1.data.code}</Badge>)

                  if(work_shifts.length - 1 == ws_index){
                    let appointment = is_machine;

                    let workshiftsEnd = <div style={{display: "flex", flexDirection: "row", gap: "5px"}}>{workshifts}</div>

                    if(appointment == 1){
                      appointment = "Automático"
                    }else{
                      appointment = "Manual"
                    }

                    array.push({
                      Máquina: description+code,
                      ["Planta"]:factory.factory_name,
                      Setor:department,
                      Turno: workshiftsEnd,
                      "Meta OEE": `${oee_goal}%`,
                      Apontamento: appointment,
                    });

                    if(response.data.length - 1 == index && array.length > 0){
                      setData(array);
                      setDataFilter(array);
                      setLoading(false);
                    }
                  }

                  

                }).catch((error)=>{
                  console.log(error)
                })
              })


              
              
            });
            
           
          })
          .catch((err) => {
            alert(err);
          });  
        }

        firstLoad();
        
    },[])

    useEffect(()=>{
      //Captura o nome dos filtros que estão sendo usados.
      let aux = Object.keys(filters);
      //Se existir uma filtragem ele usa a função .filter para filtrar o state data e armazenar em uma variável arr. 
      if(aux.length > 0 && filters[aux] != null && filters[aux] != ""){
          let arr = data.filter(element => (element[aux] == filters[aux]));
          
          //Depois ele armazena a varíavel arr no state dataFilter;
          setDataFilter([...arr]);
        
          console.log("State 'dataFilter'");
          console.log(dataFilter);

      }else{
        setDataFilter([...data]);
      }

      setLoading(false);
    },[control])

    //Essa função serve para capturarmos e armazenarmos em um state "filters" o que está sendo digitado nos filtros.

    const saveText = (element) => {
      
        const {value, name} = element;
        setFilters({[`${name}`]:(value)});
        
    }

    // Essa função é executada quando clicamos em um botão.

    const button = () => {
      setLoading(true);
      setControl([...[1]])
    } 



    
    return(
      <div className="filters boxReport">
      <FilterBox title="Filtros">
      <div className="elementFilter" type="input">
              <InputReport name="Máquina" title="Máquina" parentCallback={saveText} value={filters['Máquina']} max={30} validationType="varchar" focus={true}/>
          </div>
          <div className="elementFilter" type="input">
              <InputReport name="Planta" title="Planta" value={filters['Planta']} max={30} validationType="varchar" parentCallback={saveText}/>
          </div>
          <div className="elementFilter" type="input">
              <InputReport name="Setor" title="Setor" value={filters['Setor']} max={30} validationType="varchar" parentCallback={saveText}/>
          </div>
          <div className="buttonFilter" type="button">
              <Button size title="Gerar" icon="faGear" parentCallback={button}/>
          </div>
      </FilterBox>
      <div className="TableReport" id="tabela">
      {loading ? (
        
        <div style={{ marginTop: '20vh' }} className={styles.loader}>
          <Spinner variant="success" animation="border" />
          <strong>Carregando...</strong>
        </div>         
    ) : (
      <>
        {dataFilter.length > 0 ? (

            <TableList data={dataFilter}></TableList>
            
        ) : (

            <MessageTable message={"Sem dados para processar."} />

        )}
        </>
    )}
       </div>
    </div>
    );
};

export default reportMachines;